/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useState } from "react";
import { Buffer } from 'buffer';
// import OpenAI from "openai";
import { VolumeUp } from '@mui/icons-material';
import { IconButton } from "@mui/material";

const AudioPlayer = ({ inputText }) => {
  const [audioUrl, setAudioUrl] = useState(null);

  const playAudio = async () => {
    try {
      setAudioUrl(null);

      const {protocol} = window.location
      // "http://localhost:3002/tts/tts"
      const response = await fetch( `${protocol}/llm/tts/tts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          text: inputText,
          voice: "echo",
        }),
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch audio");
      }
      const arrayBuffer = await response.arrayBuffer();
      const buffer = Buffer.from(arrayBuffer);
      const audioBlob = new Blob([buffer], { type: "audio/mpeg" });
      const audioURL = URL.createObjectURL(audioBlob);
      setAudioUrl(audioURL);
    } catch (error) {
      console.error("Audio playback error:", error.message);
    }
  };

  return <>
  <IconButton
    onClick={playAudio}
    sx={ { backgroundColor: '#f5f5f5', color: '#9b9b9b', width: 25, height: 25, borderRadius: '5px', '&:hover': { backgroundColor: '#eee' }, border:"1px solid #e0e0e0", fontSize:"15px", padding:"0", margin:"0", marginLeft:"5px" }}>
    <VolumeUp sx={{ fontSize: "18px" }} />
  </IconButton>
  {audioUrl ? <audio autoPlay src={audioUrl} /> : null}</>; // eslint-disable-line
};

export default AudioPlayer;
